import { every, isEqual } from "lodash";
import { getValueFilters } from "PFApp/use_filtered_collection/format_filters";
import { Meta } from "PFTypes";
import { useMemo } from "react";

type Counter = {
  code: string;
  filters: {
    fields: Record<string, any>;
  };
};

export const useActiveCounter = (counters: Counter[], meta: Meta): string | undefined => {
  const activeCounter = useMemo(
    () =>
      counters.find(({ filters }) =>
        every(Object.keys(filters.fields), (filterKey) =>
          isEqual(filters.fields[filterKey], getValueFilters(meta.filters).fields?.[filterKey])
        )
      )?.code,
    [counters, meta]
  );

  return activeCounter;
};
